(function () {
  'use strict';

  const IMAGE_MAP = {
    // Sunglasses — Edit
    'bestsellers':            'https://cdn.shopify.com/s/files/1/IMAGE_PATH_BESTSELLERS.jpg',
    'classic black':          'https://cdn.shopify.com/s/files/1/IMAGE_PATH_CLASSIC_BLACK.jpg',
    'heritage tortoise':      'https://cdn.shopify.com/s/files/1/IMAGE_PATH_HERITAGE_TORTOISE.jpg',
    'soft oval':              'https://cdn.shopify.com/s/files/1/IMAGE_PATH_SOFT_OVAL.jpg',
    'structured rectangular': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_STRUCTURED_RECTANGULAR.jpg',

    // Sunglasses — By Collection
    'romi':        '',
    'bibi':        '',
    'valentina':   '',
    'juno':        '',
    'margot':      '',
    'nina':        '',

    // Jewellery — By Category
    'earrings':  'https://cdn.shopify.com/s/files/1/IMAGE_PATH_EARRINGS.jpg',
    'necklaces': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_NECKLACES.jpg',

    // Jewellery — By Style
    'silver': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_SILVER.jpg',
    'gold':   'https://cdn.shopify.com/s/files/1/IMAGE_PATH_GOLD.jpg',
    'pearls': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_PEARLS.jpg',
  };

  const PLACEHOLDER = 'IMAGE_PATH';

  function setImage(bannerImg, src) {
    bannerImg.removeAttribute('srcset');
    bannerImg.removeAttribute('sizes');
    bannerImg.src = src;
  }

  function init() {

    // On link hover — swap image and let it stick
    document.addEventListener('mouseover', function (e) {
      const link = e.target.closest('.mega-menu--wide a');
      if (!link) return;

      const panel = link.closest('.mega-menu--wide');
      if (!panel) return;

      const bannerImg = panel.querySelector('.mega-menu__banner img');
      if (!bannerImg) return;

      // Store default once per panel open
      if (!bannerImg.dataset.defaultSrc) {
        bannerImg.dataset.defaultSrc = bannerImg.src;
        bannerImg.dataset.defaultSrcset = bannerImg.getAttribute('srcset') || '';
        bannerImg.dataset.defaultSizes = bannerImg.getAttribute('sizes') || '';
      }

      const key = link.textContent.trim().toLowerCase();
      const newSrc = IMAGE_MAP[key];

      if (newSrc && !newSrc.includes(PLACEHOLDER)) {
        setImage(bannerImg, newSrc);
      }
    });

    // Reset only when mouse leaves the entire mega menu panel
    document.querySelectorAll('.mega-menu--wide').forEach(function (panel) {
      panel.addEventListener('mouseleave', function () {
        const bannerImg = panel.querySelector('.mega-menu__banner img');
        if (!bannerImg || !bannerImg.dataset.defaultSrc) return;
        if (bannerImg.dataset.defaultSrcset) bannerImg.setAttribute('srcset', bannerImg.dataset.defaultSrcset);
        if (bannerImg.dataset.defaultSizes) bannerImg.setAttribute('sizes', bannerImg.dataset.defaultSizes);
        bannerImg.src = bannerImg.dataset.defaultSrc;
        // Clear stored default so it re-reads fresh next open
        delete bannerImg.dataset.defaultSrc;
      });
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
